import { render, staticRenderFns } from "./ContractChatPrice.vue?vue&type=template&id=3870de02&scoped=true&lang=pug"
import script from "./ContractChatPrice.vue?vue&type=script&lang=js"
export * from "./ContractChatPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3870de02",
  null
  
)

export default component.exports